module.exports = __webpack_public_path__ + "static/img/login-word.215b3c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/login-word.png
// module id = qtK8
// module chunks = 1